<template>
  <MDBAlert class="spa-snackbar" position="bottom-right" stacking appendToBody :delay="3000" v-bind="$attrs">
    <slot></slot>
  </MDBAlert>
</template>
<style lang="scss">
// Because of its appendToBody nature, it cannot be scoped.
.spa-snackbar {
  min-width: 343px;
  padding: 16px 14px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: $neutral-0;
  background-color: black;
}
</style>
<script>
import { MDBAlert } from 'mdb-vue-ui-kit';
export default {
  name: 'SPASnackbar',
  components: {
    MDBAlert,
  },
};
</script>
